module.exports = __webpack_public_path__ + "img/swift-booster-green-naranja-monarca.8b84bae6.png";